import { PaperProps } from '@mui/material';

import StyledPaper from '@webclient/components/search-forms/gamification-search/actions/bots-selector/components/paper/styles';

type Props = PaperProps;

export default function Paper(props: Props) {
  return (
    <StyledPaper
      square
      {...props}
    />
  );
}
